var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHashtag = function SvgHashtag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_117_11671",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H18V17.9658H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_117_11671)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30281 7.43667H11.0962L10.3667 10.5555H6.57332L7.30281 7.43667ZM6.96276 0.00587833C6.27996 0.0592889 5.71231 0.554019 5.56447 1.22379L4.83498 4.31849H2.41539C2.36287 4.31576 2.31035 4.31576 2.25743 4.31849C1.39799 4.36215 0.736586 5.09587 0.780161 5.95706C0.824125 6.81826 1.55634 7.48102 2.41539 7.43735H4.09342L3.36393 10.5562H1.63727C1.58474 10.5535 1.53222 10.5535 1.47931 10.5562C0.619867 10.5999 -0.0415398 11.3336 0.00203526 12.1948C0.0459994 13.056 0.778216 13.7187 1.63727 13.6751H2.62237L2.0629 16.0384C1.86331 16.8793 2.38193 17.723 3.22075 17.923C4.05957 18.123 4.90151 17.6037 5.1011 16.7631C5.10148 16.7612 5.10226 16.7592 5.10265 16.7573L5.83214 13.6751H9.62551L9.06604 16.0384C8.86645 16.8793 9.38507 17.723 10.2239 17.923C11.0627 18.123 11.9046 17.6037 12.1046 16.7631L12.1058 16.7573L12.8353 13.6751H15.6435C16.503 13.6872 17.2099 12.9991 17.222 12.1379C17.234 11.2767 16.5473 10.5683 15.6879 10.5562C15.6731 10.5562 15.6587 10.5562 15.6435 10.5562H13.5768L14.3063 7.43735H16.4217C17.2811 7.44944 17.988 6.76134 18.0001 5.90014C18.0121 5.03895 17.3255 4.33057 16.466 4.31849C16.4512 4.31849 16.4368 4.31849 16.4217 4.31849H15.0479L15.6074 1.94269C15.8186 1.10801 15.3144 0.259286 14.481 0.0475931C14.3129 0.00509861 14.1386 -0.00932613 13.9659 0.00587833C13.2831 0.0592889 12.7154 0.554019 12.5676 1.22379L11.8381 4.31849H8.04475L8.60422 1.94269C8.81548 1.10801 8.31086 0.259286 7.47788 0.0475931C7.30981 0.00509861 7.13551 -0.00932613 6.96276 0.00587833Z",
    fill: "white"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHashtag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hashtag.f0cc7504.svg";
export { ForwardRef as ReactComponent };